function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import React, { Component } from 'react';
import { translationUtils } from '@wix/photography-client-lib';
import businessPackageImage from '../../../assets/images/fullscreen-store/business-package.svg';
import info from '../../../assets/images/fullscreen-store/info.svg';
var UpgradeToBusinessPopup = /*#__PURE__*/function (_Component) {
  function UpgradeToBusinessPopup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(UpgradeToBusinessPopup, _Component);
  var _proto = UpgradeToBusinessPopup.prototype;
  _proto.onCloseClick = function onCloseClick() {
    var closePopup = this.props.closePopup;
    closePopup();
  };
  _proto.onUpgradePlanClick = function onUpgradePlanClick() {
    var businessPlanUrl = this.props.businessPlanUrl;
    window.open(businessPlanUrl, '_blank');
  };
  _proto.getUserContent = function getUserContent() {
    var _this = this;
    return /*#__PURE__*/React.createElement("div", {
      className: "cp-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cp-image"
    }, /*#__PURE__*/React.createElement("img", {
      src: businessPackageImage
    })), /*#__PURE__*/React.createElement("div", {
      className: "cp-title"
    }, translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_Title')), /*#__PURE__*/React.createElement("div", {
      className: "cp-subtitle"
    }, translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_Text')), /*#__PURE__*/React.createElement("button", {
      className: "cp-button",
      onClick: function onClick() {
        return _this.onUpgradePlanClick();
      },
      target: "_blank"
    }, translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_CTA_Primary')), /*#__PURE__*/React.createElement("button", {
      className: "cp-secondary-button",
      onClick: function onClick() {
        return _this.onCloseClick();
      },
      target: "_blank"
    }, translationUtils.getByKey('Gallery_ArtStore_User_Checkout_PopUp_Upgrade_CTA_Secondary')));
  };
  _proto.getUouContent = function getUouContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "cp-content cp-content-uou"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cp-info-icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: info
    })), /*#__PURE__*/React.createElement("div", {
      className: "cp-title"
    }, translationUtils.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_Title')), /*#__PURE__*/React.createElement("div", {
      className: "cp-subtitle"
    }, translationUtils.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_Text')), /*#__PURE__*/React.createElement("button", {
      className: "cp-secondary-button",
      onClick: this.onCloseClick.bind(this),
      target: "_blank"
    }, translationUtils.getByKey('Gallery_ArtStore_UoU_Checkout_PopUp_NoPaymentsConnected_CTA')));
  };
  _proto.getCloseIcon = function getCloseIcon() {
    var _this2 = this;
    return /*#__PURE__*/React.createElement("svg", {
      className: "cp-x-button",
      onClick: function onClick() {
        return _this2.onCloseClick();
      },
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12",
      viewBox: "0 0 15 15"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 .6l-.6-.6-6.9 6.9L.6 0 0 .6l6.9 6.9L0 14.4l.6.6 6.9-6.9 6.9 6.9.6-.6-6.9-6.9"
    }));
  };
  _proto.render = function render() {
    var _this$props = this.props,
      viewMode = _this$props.viewMode,
      isMobile = _this$props.isMobile;
    return /*#__PURE__*/React.createElement("div", {
      className: "artstore-popup-message-element " + (isMobile ? 'artstore-popup-message-element-mobile' : '')
    }, this.getCloseIcon(), viewMode === 'site' ? this.getUouContent() : this.getUserContent());
  };
  return UpgradeToBusinessPopup;
}(Component);
export { UpgradeToBusinessPopup as default };